import LensCard from "./LensCard.jsx";

export default function LensCardGrid({ lenses, favoriteIds, activeLensId, busyLensId, onApply, onFavorite, empty }) {
  if (!lenses.length) return <div className="lens-library-empty">{empty || "No lenses found."}</div>;
  return (
    <div className="lens-card-grid">
      {lenses.map((lens) => (
        <LensCard
          key={lens.lensId}
          lens={lens}
          favorite={favoriteIds.has(lens.lensId)}
          active={activeLensId === lens.lensId}
          busy={busyLensId === lens.lensId}
          onApply={onApply}
          onFavorite={onFavorite}
        />
      ))}
    </div>
  );
}
